import React, {useEffect, useState} from "react";
import styles from "./test-result-page.module.css";
import RoutesToPages from "../../assets/RoutesToPages/Routes";
import {useNavigate} from "react-router-dom";
import ServerRequest from "../../ServerRequests/ServerRequest";


const TestResultPage = () => {
  const [stressPercent, setStressPercent] = useState(0);
  const [depressionPercent, setDepressionPercent] = useState(0);
  const navigate = useNavigate();
  const identifiableData = JSON.parse(localStorage.getItem('testResultsParams')) ?? null;


  useEffect(() => {
    if (!identifiableData) return;
    ServerRequest.identifyUserData(identifiableData);
  }, []);


  useEffect(() => {
    // Отримуємо збережені значення з localStorage
    const savedStress = localStorage.getItem("stressPercent");
    const savedDepression = localStorage.getItem("depressionPercent");

    if (savedStress && savedDepression) {
      // Якщо значення вже є - використовуємо їх
      animateProgress(setStressPercent, parseInt(savedStress));
      animateProgress(setDepressionPercent, parseInt(savedDepression));
    } else {
      // Генеруємо нові випадкові значення із заданих меж
      const newStress = getRandomInRange(66, 77);
      const newDepression = getRandomInRange(19, 29);

      // Зберігаємо нові значення
      localStorage.setItem("stressPercent", newStress.toString());
      localStorage.setItem("depressionPercent", newDepression.toString());

      // Анімуємо прогрес
      animateProgress(setStressPercent, newStress);
      animateProgress(setDepressionPercent, newDepression);
    }
  }, []);


  // Функція для генерації випадкового числа в діапазоні
  const getRandomInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };


  const animateProgress = (setState, target) => {
    let current = 0;
    const duration = 2000;
    const intervalTime = duration / target;

    const interval = setInterval(() => {
      if (current >= target) {
        clearInterval(interval);
      } else {
        current++;
        setState(current);
      }
    }, intervalTime);
  };


  const ProgressBar = ({label, percent}) => {
    return (
      <div className={styles.progressContainer}>
        <div className={styles.blockTitle}>{label}</div>
        <div className={styles.progressBarOuter}>
          <span
            className={styles.progressNumbersMain}
            style={{color: percent > 50 ? "white" : "#303030"}}
          >
            {percent}%
          </span>
          <div
            className={styles.progressBarInner}
            style={{width: `${percent}%`}}
          ></div>
        </div>
        <div className={styles.progressNumbers}>
          <span className={styles.progressStartNumber}>0%</span>
          <span className={styles.progressEndNumber}>100%</span>
        </div>
      </div>
    );
  };


  return (
    <div className={styles['general-container']}>
      <div className={styles.container}>
        <h1 className={styles.title}>Test Results</h1>

        <ProgressBar label="Your Stress Level:"
                     percent={stressPercent}/>
        <ProgressBar label="Your Depression Level:"
                     percent={depressionPercent}
        />

        <p className={styles.stressDescription}>
          You show mild signs of stress. This is normal, especially during periods of pressure or major life changes.
          You may feel somewhat tired, irritable, or prefer to be alone for a while. You need some rest and self-care.
          Take a break, listen to your favorite music, go for a walk, or do something enjoyable for yourself.</p>

        <div className={`${styles.blockTitle} ${styles.blockTitleBigMargin}`}>
          Other Mental Health Indicators
        </div>

        <img
          src={require("../TestResultPage/img/diagramm.png")}
          alt="Other mental health indicators:"
          className={styles.resultImage}
        />

        <div className={styles.blockDiagram}>
          <button className={styles.blockDiagramButton}>Total Score: 34</button>
        </div>

        <div className={`${styles.blockTitle} ${styles.blockTitleBigMargin}`}>
          Mental Health Test Score Interpretation
        </div>

        <ul className={styles.pointsList}>
          <li>
            <strong>0–9 points </strong>
            <span> – No issues detected, your mental state is normal</span>
          </li>
          <li>
            <strong>10–18 points</strong>
            <span> – Mild distress, slight emotional fluctuations may occur
          </span>
          </li>
          <li>
            <strong>19–27 points</strong>
            <span> – Moderate condition, it is advisable to pay attention to your feelings
            </span>
          </li>
          <li>
            <strong>28–36 points</strong>
            <span> – Clear signs of stress; rest and support are recommended
            </span>
          </li>
          <li>
            <strong>37–45 points</strong>
            <span> – Recurring issues; it is time to focus on your mental health
            </span>
          </li>
          <li>
            <strong>46–54 points</strong>
            <span> – Noticeable difficulties; speaking with a specialist is recommended
            </span>
          </li>
          <li>
            <strong>55–63 points</strong>
            <span> – Significant problems; consulting a mental health professional is important          </span>
          </li>
          <li>
            <strong>64–70 points</strong>
            <span> – Serious problems; immediate professional intervention is required
            </span>
          </li>
        </ul>

        <p className={styles['age-gender-result-title']}>Normal Indicators by Age and Gender</p>
        <img
          src={require("../TestResultPage/img/chart-1.png")}
          alt="Age and gender diagramm:"
          className={styles.resultImage}
        />
        <span className={styles["table_text"]}>Chart 1: Men</span>
        <div className={styles["green-divider"]}></div>

        <img
          src={require("../TestResultPage/img/chart-2.png")}
          alt="Age and gender diagramm:"
          className={styles.resultImage}
        />
        <span className={styles["table_text"]}>Chart 2: Women</span>
        <div className={styles["green-divider"]}></div>

        <div className={`${styles.blockTitle} ${styles.blockTitleBigMargin}`}>
          Your indicators are within the normal range.
        </div>

        <span className={styles.lastText}>
          Discover how to maintain your mental well-being more effectively with our AvokaDo service.
      </span>

        <div
          className={styles.redirectToService}
          onClick={() => navigate(RoutesToPages.welcomePage)}
        >
          <span className={styles.redirectToServiceButton}>Continue</span>
        </div>
      </div>
    </div>
  );
};

export default TestResultPage;
